/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../richText';

const Note = ({
  type,
  text,
  data,
  options,
  isWarningMessage,
  isShowNoteBackground,
  isItalicNote,
  isColorRed,
  noteStyle
}) => {
  return (
    <div
      className={`${
        isShowNoteBackground
          ? 'informational_message'
          : 'informational_message_without_border'
      }`}
      style={noteStyle}
    >
      <span
        className={`frg-body-font-14px wrap-white-space ${
          isWarningMessage ? 'warning-information-message' : ''
        }`}
      >
        {type === 'richText' ? (
          <RichText
            data={data}
            options={options}
            isItalicNote={isItalicNote}
            isColorRed={isColorRed}
            textColor={noteStyle && noteStyle.color}
          />
        ) : (
          <p className={`${isShowNoteBackground ? '' : '.jNhCkQ'}`}>{text}</p>
        )}
      </span>
    </div>
  );
};

Note.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  isColorRed: PropTypes.bool,
  isItalicNote: PropTypes.bool,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }),
  isWarningMessage: PropTypes.bool,
  noteStyle: PropTypes.object,
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  })
};

Note.defaultProps = {
  type: 'text',
  text: '',
  options: {
    renderMark: {},
    renderNode: {}
  },
  isWarningMessage: false,
  noteStyle: {}
};

export default Note;
